import script from "./PatientListHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientListHeader.vue?vue&type=script&lang=ts&setup=true"

import "./PatientListHeader.vue?vue&type=style&index=0&id=526d4a63&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-526d4a63"]])

export default __exports__